import { useCallback, useState } from 'react';

import { downloadSignReceiptExcel } from '#/api/aftersalesMgmt/signReceipt/downloadExcel';
import { getSignReceiptApiErrorMessage } from '#/modules/crmMgmt/aftersales/signReceipt/helper/apiError';
import { getFileTransferErrorMessage } from '#/utils/blobResponseError';
import { triggerBlobDownload } from '#/utils/downloadBlob';
import { toast } from '#/utils/toast';

function useSignReceiptExcelDownload(id) {
  const [isPrintPending, setIsPrintPending] = useState(false);

  const handlePrint = useCallback(async () => {
    if (!id || isPrintPending) {
      return;
    }

    setIsPrintPending(true);
    try {
      const { blob, filename } = await downloadSignReceiptExcel(id);
      triggerBlobDownload(blob, filename);
    } catch (error) {
      toast.error(
        getFileTransferErrorMessage(error)
        || getSignReceiptApiErrorMessage(error, '下載 Excel 失敗'),
      );
    } finally {
      setIsPrintPending(false);
    }
  }, [id, isPrintPending]);

  return {
    canPrint: Boolean(id),
    isPrintPending,
    handlePrint,
  };
}

export default useSignReceiptExcelDownload;
